import { parseMessageData } from '@inbox-demo-nx/utils-data-utils';
import SendBird from 'sendbird';

export type AnySendBirdMessage =
  | SendBird.UserMessage
  | SendBird.AdminMessage
  | SendBird.FileMessage;

export function getChannelUpdatedAt(channel: SendBird.GroupChannel) {
  return channel.lastMessage?.createdAt ?? channel.createdAt;
}

export function getMessagePreviewText(message: AnySendBirdMessage) {
  const messageData = parseMessageData(message.data);
  if (messageData?.previewText) {
    return messageData.previewText;
  }
  if (message.isFileMessage()) {
    if (message.type?.includes('image')) {
      return 'Sent an image';
    }
    if (message.type?.includes('audio')) {
      return 'Sent a voice memo';
    }
    return 'Sent a file';
  }
  return message.message?.split('\n')?.join(' ') ?? '';
}

export function getLastMessage(channel: SendBird.GroupChannel) {
  return channel.lastMessage && getMessagePreviewText(channel.lastMessage);
}

export * from './formatDuration';
export * from './formatters';
export * from './isChannelVerified';
export * from './isFAQBotAnswer';
export * from './isMessageVisible';
export * from './useFormatDateLine';
export * from './useGetChannelTitle';
